module.exports = __webpack_public_path__ + "static/media/document.8b669297.svg";